/**
 * Work out if any part of our popover is going to be offscreen and style the popover accordingly.
 * There are 6 positions relative to the click position:
 * - left / underneath
 * - centre / underneath (default)
 * - right / underneath
 * - left / above
 * - centre / above
 * - right / above
 *
 * @param {PointerEvent} event
 * @param {DOMRect} tableBoundingRect
 * @param {number} firstColumnWidth
 *
 * @return {{tooltipStyles: {}, arrowPosition: string}}
 */
const setTooltipPosition = (event, tableBoundingRect, firstColumnWidth) => {
    let tooltipStyles = {};
    let arrowPosition = 'top-centre';

    const sessionHeightPx = 52;
    const tooltipWidthPx = 220;
    const tooltipShadowPx = 4;
    const tooltipCentrePx = ((tooltipWidthPx + tooltipShadowPx + tooltipShadowPx) / 2);
    const tooltipHeightPx = 200; // This can vary but 200 is good average.

    let okLeft = true;
    let okRight = true;
    let okBottom = true;
    // We don't need to worry about okTop as the tooltip is underneath by default.

    // Remember:
    // clientX is the distance from the left edge of the visible window, unaffected by scrolling. This is also the
    // distance from the left hand edge of the table becuase teh table is full width.
    //
    // offsetX is the distance from the top-left corner of the specific element where the event occurred. In this
    // case that is the individual session track.

    if ((event.clientX - tooltipCentrePx) < firstColumnWidth) {
        okLeft = false;
    }

    if ((event.clientX + tooltipCentrePx) > tableBoundingRect.right) {
        okRight = false;
    }

    if ((event.clientY + tooltipHeightPx) > tableBoundingRect.height) {
        okBottom = false;
    }

    let styleLeftPx = event.offsetX - tooltipCentrePx;
    let styleTopPx = sessionHeightPx;
    let styleBottomPx = sessionHeightPx;

    if (!okLeft && !okBottom) {
        styleTopPx = null;
        styleLeftPx = event.offsetX - tooltipShadowPx;
        arrowPosition = 'bottom-left';
    } else if (!okRight && !okBottom) {
        styleTopPx = null;
        styleLeftPx = event.offsetX - tooltipWidthPx + tooltipShadowPx;
        arrowPosition = 'bottom-right';
    } else if (!okLeft) {
        styleLeftPx = event.offsetX - tooltipShadowPx;
        arrowPosition = 'top-left';
    } else if (!okRight) {
        styleLeftPx = event.offsetX - tooltipWidthPx + tooltipShadowPx;
        arrowPosition = 'top-right';
    } else if (!okBottom) {
        styleTopPx = null;
        arrowPosition = 'bottom-centre';
    } else {
        // No part of the tooltip will be offscreen. We can just display with the defaults.
    }

    tooltipStyles.left = styleLeftPx + 'px';

    if (styleTopPx) {
        tooltipStyles.top = styleTopPx + 'px';
    }

    if (!styleTopPx) {
        tooltipStyles.bottom = styleBottomPx + 'px';
    }

    return {
        arrowPosition,
        tooltipStyles,
    };
};

module.exports = {
    setTooltipPosition,
};
